import FundingNotesContainer from "./FundingNotes.container";

export default FundingNotesContainer;
